<template>
  <div class="row">
    <div class="col-md-6 offset-md-3 col-sm-12">

      <div class="alert alert-success" v-if="message">
        {{ message }}
      </div>
      <div class="alert alert-danger" v-show="errors">
        Your credentials doesn't match anything on database
      </div>

      <div class="m-portlet">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
						<span class="m-portlet__head-icon m--hide">
						<i class="la la-gear"></i>
						</span>
              <h3 class="m-portlet__head-text">
                Login
              </h3>
            </div>
          </div>
        </div>
        <div class="m-portlet__body">

          <!--begin::Form-->
          <form class="mt-3" @submit.prevent="onSubmit">

            <div class="form-group" :class="{invalid: $v.email.$error}">
              <label for="email">Email</label>
              <input type="email"
                     class="form-control"
                     id="email"
                     @blur="$v.email.$touch()"
                     v-model="email">
            </div>

            <div class="form-group" :class="{invalid: $v.password.$error}">
              <label for="password">Password</label>
              <input type="password"
                     class="form-control"
                     id="password"
                     @blur="$v.password.$touch()"
                     v-model="password">
            </div>
            <button type="submit" class="btn btn-dark" :disabled="$v.$invalid">Login</button>
          </form>

          <router-link :to="{ name: 'reset_password.request' }" class="mt-3 link" tag="div">Forgot password</router-link>
          <!--end::Form-->
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {email, required} from 'vuelidate/lib/validators'
import {mapActions} from 'vuex'

export default {

  props: [
    'message'
  ],

  data() {
    return {
      email: '',
      password: '',
      errors: false
    }
  },

  methods: {
    ...mapActions('auth', ['login']),

    onSubmit() {
      const formData = {
        email: this.email,
        password: this.password,
        dt: localStorage.getItem('dt'),
      }

      this.message = null;

      this.axios.post('/login', formData)
        .then(res => this.login(res.data))
        .catch(error => {
          this.errors = true
          console.log(error)
        })
    }
  },

  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    }
  }
}
</script>

<style scoped>

.form-group.invalid label {
  color: red;
}

.form-group.invalid input {
  border: 1px solid red;
  background-color: #ffc9aa;
}

.link {
  cursor: pointer;
  color: #2E4EFF;
}

.link:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/auth/LoginPage.vue